<template>
  <div class="my-news">
    <el-card class="news-card">
      <div slot="header" class="clearfix">
        <span>新闻管理</span>
        <el-button style="float: right; padding: 3px 0" type="primary" @click="handleAdd" icon="el-icon-plus">新增新闻</el-button>
      </div>
      
      <!-- 新闻列表 -->
      <el-table :data="newsList" style="width: 100%" v-loading="loading" stripe>
        <el-table-column prop="id" label="ID" width="40" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" width="120"></el-table-column>
        <el-table-column prop="subtitle" label="副标题" width="200"></el-table-column>
        <el-table-column prop="category" label="分类" width="80" align="center"></el-table-column>
        <el-table-column prop="pageview" label="浏览数" width="80" align="center"></el-table-column>

        <el-table-column prop="create_time" label="创建时间" width="100" align="center">
            <template slot-scope="scope">
              {{ $hnwTools.formatDateTime(scope.row.create_time, 'ymd') || '--' }}
            </template>
        </el-table-column>
        <el-table-column label="操作" width="280" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini"  @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="success" @click="handleTop(scope.row)">置顶</el-button>
            <!-- sort -->
            <el-button size="mini" type="primary" @click="handleRecommend(scope.row)">推荐</el-button>
            <!-- is_push -->
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Number(total)"
        background
        style="margin-top: 20px; text-align: center;">
      </el-pagination>
    </el-card>
    
    <!-- 新闻详情对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="80%" @close="handleDialogClose" :fullscreen="dialogFullscreen">
      <el-form :model="currentNews" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="currentNews.title" placeholder="请输入新闻标题"></el-input>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload
            :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
            :data="{store_id:this.$store.state.store_id}"
            :headers="{'token':$store.state.token}"
            name="image"
            list-type="picture-card"
            :on-success="upImgSuccess"
            :on-remove="handleRemovePicture"
            :limit="1"
            multiple
            :file-list="pictureFileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="currentNews.subtitle" placeholder="请输入新闻副标题"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="currentNews.category" placeholder="请选择新闻分类" style="width: 100%">
            <el-option label="荣誉资讯" value="荣誉资讯"></el-option>
            <el-option label="文化传承" value="文化传承"></el-option>
            <el-option label="展会信息" value="展会信息"></el-option>
            <el-option label="公司资讯" value="公司资讯"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <quill-editor 
            v-model="currentNews.content" 
            :options="editorOption"
            style="min-height: 300px;">
          </quill-editor>
          
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleFullscreen">{{ dialogFullscreen ? '退出全屏' : '全屏' }}</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveNews">确 定</el-button>
      </span>
    </el-dialog>
    
    <!-- 查看新闻详情对话框 -->
    <el-dialog title="新闻详情" :visible.sync="viewDialogVisible" width="80%" :fullscreen="viewDialogFullscreen">
      <div v-if="currentNews">
        <h2 style="text-align: center; margin-bottom: 20px;">{{ currentNews.title }}</h2>
        <h3 style="text-align: center; margin-bottom: 20px; color: #666;">{{ currentNews.subtitle }}</h3>
        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <p><strong>分类:</strong> {{ currentNews.category }}</p>
          <p><strong>发布时间:</strong> {{ currentNews.create_time }}</p>
        </div>
        <div class="news-content ql-editor" v-html="currentNews.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleViewFullscreen">{{ viewDialogFullscreen ? '退出全屏' : '全屏' }}</el-button>
        <el-button @click="viewDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      viewDialogVisible: false,
      dialogTitle: '',
      dialogFullscreen: false,
      viewDialogFullscreen: false,
      currentNews: {
        id: '',
        title: '',
        subtitle: '',
        category: '',
        content: '',
        picture: ''
      },
      pictureFileList: [],
      editorOption: {
        theme: 'snow',
        placeholder: '请输入新闻内容...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
          ]
        }
      }
    }
  },
  methods: {
    // 获取新闻列表
    async getNewsList() {
      this.loading = true
      try {
        const res = await this.$api.getNewsList({
          page: this.currentPage,
          limit: this.pageSize
        })
        this.newsList = res.db || []
        this.total = res.total || 0
      } catch (error) {
        this.$message.error('获取新闻列表失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    
    // 处理新增
    handleAdd() {
      this.dialogTitle = '新增新闻'
      this.currentNews = {
        id: '',
        title: '',
        subtitle: '',
        category: '',
        content: '',
        picture: ''
      }
      this.pictureFileList = [] // 清空主图列表
      this.dialogFullscreen = false
      this.dialogVisible = true
    },
    
    // 处理编辑
    handleEdit(row) {
      this.dialogTitle = '编辑新闻'
      this.currentNews = { ...row }
      // 设置主图文件列表
      if (row.picture) {
        this.pictureFileList = [{
          name: '主图',
          url: row.picture
        }];
      } else {
        this.pictureFileList = [];
      }
      this.dialogFullscreen = false
      this.dialogVisible = true
    },
    
    // 处理推荐
    async handleRecommend(row) {
      try {
        await this.$api.setArticleField({
          id: row.id,
          field: 'is_push',
          value: 1
        })
        this.$suMsg('推荐成功!')
        this.getNewsList() // 重新加载列表
      } catch (error) {
        this.$message.error('推荐失败: ' + error.message)
      }
    },
    
    // 处理置顶
    async handleTop(row) {
      try {
        // 先获取所有新闻的最大sort值
        let maxSort = 0;
        if (this.newsList && this.newsList.length > 0) {
          // 过滤出有效的sort值并找到最大值
          const validSorts = this.newsList
            .map(item => parseInt(item.sort))
            .filter(sort => !isNaN(sort));
          maxSort = validSorts.length > 0 ? Math.max(...validSorts) : 0;
        }
        
        await this.$api.setArticleField({
          id: row.id,
          field: 'sort',
          value: maxSort + 1
        })
        this.$suMsg('置顶成功!')
        this.getNewsList() // 重新加载列表
      } catch (error) {
        this.$message.error('置顶失败: ' + error.message)
      }
    },
    
    // 处理删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除该新闻, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$api.delArticle({ id: row.id })
          this.$suMsg('删除成功!')
          this.getNewsList() // 重新加载列表
        } catch (error) {
          this.$message.error('删除失败: ' + error.message)
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    // 处理查看
    handleView(row) {
      this.currentNews = { ...row }
      this.viewDialogFullscreen = false
      this.viewDialogVisible = true
    },
    
    // 保存新闻（新增或修改）
    async saveNews() {
      // if (!this.currentNews.title) {
      //   this.$message.warning('请输入新闻标题')
      //   return
      // }
      
      try {
        const data = { 
          ...this.currentNews,
          picture: this.currentNews.picture || '' // 确保picture字段被传递
        }
        await this.$api.insertArticle(data)
        this.$suMsg(this.currentNews.id ? '修改成功!' : '新增成功!')
        this.dialogVisible = false
        this.getNewsList() // 重新加载列表
      } catch (error) {
        this.$message.error((this.currentNews.id ? '修改' : '新增') + '失败: ' + error.message)
      }
    },
    
    // 关闭对话框时的处理
    handleDialogClose() {
      this.currentNews = {
        id: '',
        title: '',
        subtitle: '',
        category: '',
        content: '',
        picture: ''
      }
      this.pictureFileList = []
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val
      this.getNewsList()
    },
    
    // 切换编辑对话框全屏
    toggleFullscreen() {
      this.dialogFullscreen = !this.dialogFullscreen
    },
    
    // 切换查看对话框全屏
    toggleViewFullscreen() {
      this.viewDialogFullscreen = !this.viewDialogFullscreen
    },
    
    // 图片上传成功回调
    upImgSuccess(res) {
      console.log("图片上传成功", res);
      this.currentNews.picture = res.data.url; // 保存图片URL到picture字段
      this.pictureFileList = [{
        name: '主图',
        url: res.data.url
      }];
    },
    
    // 图片删除回调
    handleRemovePicture(file, fileList) {
      console.log("删除图片", file, fileList);
      this.currentNews.picture = ''; // 清空图片URL
      this.pictureFileList = [];
    },
  },
  created() {
    this.getNewsList()
  }
}
</script>

<style lang="scss">
.my-news {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 80px);
  
  .news-card {
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    ::v-deep .el-card__header {
      background-color: #fafafa;
      border-bottom: 1px solid #ebeef5;
      padding: 15px 20px;
    }
  }
  
  .news-content {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
    background-color: #fff;
    min-height: 200px;
    
    // 继承Quill编辑器的样式
    @import '~quill/dist/quill.core.css';
    @import '~quill/dist/quill.snow.css';
  }
  
  .el-pagination {
    margin-top: 20px;
    text-align: center;
  }
  
  .ql-container {
    min-height: 300px;
  }
  
  .ql-editor {
    min-height: 300px;
  }
}
</style>